module.exports = __webpack_public_path__ + "static/media/Puffy Style Guide.a5dc8cf3.png";